/* eslint-disable import/prefer-default-export */
export const chartPeriods = Object(
  [
    { id: 1, value: 'year', name: 'for year' },
    { id: 2, value: 'month', name: 'for month' },
    { id: 3, value: 'week', name: 'for week' },
    { id: 4, value: 'day', name: 'day' },
    { id: 5, value: 'customRange', name: 'Custom Range' },
  ].map(chartPeriod => Object(chartPeriod)),
);
